import { Box, Stack } from '@mui/material';

import { EditableRegion } from '@/components/blockEditor/EditableRegion/EditableRegion';
import { Card } from '@/components/layout/Card/Card';
import { COLORS } from '@/styles/tokens/colors';

import { EducationalSlideH3 } from '../../components/EducationalSlide.components';
import { SVGVariableContainer } from '../../components/SVGVariableContainer';
import ILITDiagram from './ILITDiagram2.svg?react';

export function IlitOverviewPageTwo() {
  return (
    <Stack direction="row" spacing={5} height="100%">
      {/* Left Column - Wrapped in Card */}
      <Card
        variant="filled"
        sx={{ p: 2, width: '35%', height: '100%', overflowY: 'auto' }}
      >
        <EditableRegion regionId="ilit-overview-page-two-list" />
      </Card>

      {/* Right Column */}
      <Stack sx={{ width: '65%', alignItems: 'center' }}>
        <Box
          sx={{
            border: `1px solid ${COLORS.NEUTRAL_GRAY[200]}`,
            height: '500px',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            width: '100%',
          }}
        >
          <Box mb={2} mt={2}>
            <EducationalSlideH3>How an ILIT works</EducationalSlideH3>
          </Box>
          <SVGVariableContainer>
            <ILITDiagram />
          </SVGVariableContainer>
        </Box>
      </Stack>
    </Stack>
  );
}
